var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLockIcon02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4248 8.29675V3.29675C19.4248 2.76632 19.2141 2.25761 18.839 1.88254C18.4639 1.50747 17.9552 1.29675 17.4248 1.29675H3.4248C2.89437 1.29675 2.38566 1.50747 2.01059 1.88254C1.63552 2.25761 1.4248 2.76632 1.4248 3.29675V9.29675C1.4248 9.82719 1.63552 10.3359 2.01059 10.711C2.38566 11.086 2.89437 11.2968 3.4248 11.2968H10.4248",
    stroke: "#234CE3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3038 12.2138C19.7978 12.5178 19.7668 13.2568 19.2588 13.3148L16.6918 13.6058L15.5408 15.9178C15.3128 16.3768 14.6078 16.1518 14.4908 15.5838L13.2358 9.46777C13.1368 8.98777 13.5688 8.68577 13.9858 8.94277L19.3038 12.2138V12.2138Z",
    stroke: "#234CE3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4248 6.30678L10.4348 6.29578M14.4248 6.30678L14.4348 6.29578M6.4248 6.30678L6.4348 6.29578",
    stroke: "#234CE3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon02);
export default __webpack_public_path__ + "static/media/lock-icon-02.0b0c7b5cf7675072c317984a81410565.svg";
export { ForwardRef as ReactComponent };